import { useMutation, useQueryClient } from '@tanstack/react-query';

import patchUpdateGiveawayItem from 'Api/brief-live/patchUpdateGiveawayItem';
import { useParams } from 'react-router-dom';
import { useToast } from 'Store/toast';
import patchUpdateGiveawayItemRequest from './model/request/patchUpdateGiveawayItemRequest';

const usePatchUpdateGiveawayItem = ({ onSuccess } = {}) => {
  const queryClient = useQueryClient();
  const { onOpenToast } = useToast();
  const { id } = useParams();
  const briefMainGiveawayId = id;

  return useMutation({
    mutationKey: ['patch-update-giveaway-item'],
    mutationFn: async ({ id, form }) => {
      const payload = patchUpdateGiveawayItemRequest({ form, briefMainGiveawayId });
      
      return await patchUpdateGiveawayItem(id, payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['giveaway-by-id'] });
      onOpenToast({
        status: 'success',
        title: 'Success',
        description: 'Hadiah giveaway berhasil diperbarui!',
        duration: 5,
        alwaysShow: false,
      });
      onSuccess?.();
    },
  });
};

export default usePatchUpdateGiveawayItem;
